export default __webpack_public_path__ + "static/media/line-drawing.7e794d5d.png";